module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-cover bg-overlay-black-5 display-table height-100 no-padding width-100",
    class: {
      'transporter': _vm.carId == 1, 'caddy': _vm.carId == 2, 'crafter': _vm.carId == 3, 'amarok': _vm.carId == 4
    },
    style: ('height:' + _vm.windowHeight + 'px!important'),
    attrs: {
      "id": "venue"
    }
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-md-offset-7"
  }, [_c('div', {
    staticClass: "mb-outer bg-white border-round padding-13 position-relative"
  }, [_c('div', {
    staticClass: "mb-inner"
  }, [_c('h3', {
    staticClass: "font-family-alt font-weight-700 letter-spacing-2 text-uppercase xs-title-small title-medium title-sideline-base-color vw-bold"
  }, [_vm._v("Bliv inspireret")]), _vm._v(" "), _c('p', {
    staticClass: "margin-4-5 no-margin-bottom no-margin-rl text-large text-gray-dark-2 vw-body"
  }, [_vm._t("text")], 2), _vm._v(" "), _c('a', {
    staticClass: "btn btn-outline-black btn-medium margin-7 no-margin-bottom no-margin-rl",
    attrs: {
      "rel": "noopener",
      "target": "_blank",
      "href": _vm.buttonLink
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72df7e66"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home-sections/promo.vue
// module id = 243
// module chunks = 1